import { ChangeDetectorRef, Component, HostListener, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import {MdbTableDirective, MdbTablePaginationComponent} from 'angular-bootstrap-md';
import { SponsoredEventsService } from '../services/sponsored-events.service';

export interface Events {
    eventid: string;
    eventname: string;
    organizer: string;
    sponsorshipdate: string;
    sponsorshipenddate: string;
    country: string;
    payment: string;
  }
  

@Component({
  selector: 'app-sponsoredevents',
  templateUrl: './sponsoredevents.component.html',
  styleUrls: ['./sponsoredevents.component.scss']
})
export class SponsoredeventsComponent implements OnInit {

  @ViewChild(MdbTablePaginationComponent, { static: true }) mdbTablePagination: MdbTablePaginationComponent;
  @ViewChild(MdbTableDirective, {static: true}) mdbTable: MdbTableDirective;

  headElements = ['Event ID', 'Event Name', 'Organizer', 'Start Date', 'End Date', 'Payment'];
  searchText: string = '';
  previous: string;
  sortForm:FormGroup;
  allSponsoredEvents:any = [];
  // date = new Date();
  startDate = new Date();

  
  constructor(private cdRef: ChangeDetectorRef, 
    private sponsoredEventService: SponsoredEventsService,
    private formBuilder:FormBuilder) {
  }

  @HostListener('input') oninput() {
      this.searchItems();
  }

  ngOnInit() {

    this.sortForm = this.formBuilder.group({
      sort:null
    })
      
      this.sponsoredEventService.getAllSponsoredEvents().then((res:any) => {
        console.log(res)
        for (let i = 0; i < res.events.data.length; i++) {
          var d = new Date(res.events.data[i].sponsorship_date);
          var countryLb
          d.setDate(d.getDate() + res.events.data[i].days);
          if (res.events.data[i].event.country == "123"){countryLb = "Lebanon"}
          
          this.allSponsoredEvents.push({ 
            id: res.events.data[i].id, 
            eventName: res.events.data[i].event.event_name,
            organizerName: res.events.data[i].event.organizer_name,
            sponsorshipDate: new Date(res.events.data[i].sponsorship_date),
            sponsorshipEndDate: d,
            country: countryLb,
            payment: res.events.data[i].amount,
           });
        }
        this.mdbTable.setDataSource(this.allSponsoredEvents);
        this.previous = this.mdbTable.getDataSource();

      


      }).catch((err) =>{
        console.log(err);
      }) 
  }

  ngAfterViewInit() {
    this.mdbTablePagination.setMaxVisibleItemsNumberTo(10);

    this.mdbTablePagination.calculateFirstItemIndex();
    this.mdbTablePagination.calculateLastItemIndex();
    this.cdRef.detectChanges();
  }

  searchItems() {
      const prev = this.mdbTable.getDataSource();
      if (!this.searchText) {
          this.mdbTable.setDataSource(this.previous);
          this.allSponsoredEvents = this.mdbTable.getDataSource();
      }
      if (this.searchText) {
          this.allSponsoredEvents = this.mdbTable.searchLocalDataBy(this.searchText);
          this.mdbTable.setDataSource(prev);
      }
  }

}